import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import {
    Checkbox,
    DialogContent,
    FormControlLabel,
    FormGroup,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';
import { Add, HorizontalRule, Info } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import * as React from 'react';
import useCheckMobileScreen from '../../utils/detect-mobile-size';
import IProduct from '../../interfaces/IProduct';
import IProductOption from '../../interfaces/IProductOption';
import IOptionGroup from '../../interfaces/IOptionGroup';
import _ from 'lodash';
import { addExtraItem, removeItem } from '../../utils/order-actions';
import { ActionButton, ActionIconButtonGrey, ActionIconButtonPlus } from '../../utils/action-button';
import { Link } from 'react-router-dom';
import ProductInformationModal from './product-information-modal';

export default function MealModal(props: any) {
    const {onClose, selectedValue, open, onAdd, setCart, cart, isEditing} = props;
    const product: IProduct = props.product;
    const [openInfoModal, setOpenInfoModal] = React.useState(false);

    const [tempAmount, setTempAmount] = useState(1);
    const [totalPrice, setTotalPrice] = useState(product.price);
    const [previousSelectedOption, setPreviousSelectedOption] = useState<IProductOption>({price: 0, name: '', id: ''});
    const [allOptions, setAllOptions] = useState<IProductOption[]>([]);

    const getDefaultOption = (): string => {
        let value = ''

        product.optionGroups.map(og => {
            if (!og.multiChoice) {
                og.options.map((opt) => {
                    if (opt.isDefault) {
                        setAllOptions(oldArray => {
                            let newArray = oldArray;
                            newArray.push(opt);
                            return newArray;
                        })

                        setPreviousSelectedOption(opt);
                        value = opt.id;
                    }
                })
            }
        })
        return value;
    }

    const [option, setOption] = useState(getDefaultOption);

    let isMobile = useCheckMobileScreen();

    const handleClose = () => {
        onClose(selectedValue);
    };

    const handleCloseInfoModal = () => {
        setOpenInfoModal(false);
    }

    const handleChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        let changedOption: IProductOption = {price: 0, name: '', id: ''};

        //Make changedOption according Object
        product.optionGroups.map(group => {
                const findVal = group.options.find(option =>
                    option.id === event.target.value
                )
                if (findVal) {
                    changedOption = findVal;
                } else {
                    console.log('kapot?', changedOption)
                }
            }
        )

        //TODO voelt hacky, kijken betere oplossing?
        if (option) {
            setTotalPrice(price => {
                //If not initial value vs initial selected value
                if (Object.keys(previousSelectedOption).length > 0) {
                    return price - previousSelectedOption.price + changedOption.price;
                } else {
                    return price + changedOption.price;
                }
            })
            setAllOptions(oldArray => {
                let array: IProductOption[] = [...oldArray];
                let optionToBeDeleted = array.findIndex(opt => opt.id === previousSelectedOption.id);

                array.splice(optionToBeDeleted, 1);
                array.push(changedOption);

                return array;
            })
        } else {
            setTotalPrice(price => price + changedOption.price);
            setAllOptions(oldArray => {
                let array: IProductOption[] = [...oldArray];
                array.push(changedOption);
                return array;
            })
        }

        setPreviousSelectedOption(changedOption);
        setOption(event.target.value);
    };

    const handleChangeBox = (event: { target: { checked: boolean; }; }, option: IProductOption) => {
        setTotalPrice(price => {
            return event.target.checked ? price + option.price : price - option.price;
        })

        setAllOptions((prevOptions) => {
            let array = [...prevOptions];
            if (event.target.checked) {
                array.push(option);
            } else {
                let optionToBeDeleted = array.findIndex(opt => opt.id === option.id);
                array.splice(optionToBeDeleted, 1);
            }
            return array;
        })
    }

    const handleAdd = () => {
        const newOptionGroup: IOptionGroup = {
            options: allOptions
        }

        const newProduct: IProduct = {
            ...product,
            optionGroups: [newOptionGroup],
            quantity: tempAmount
        }

        onAdd(newProduct);
        handleClose();
    }

    const addExtraItem = () => {
        setTempAmount(tempAmount + 1);
    }

    const removeItem = () => {
        if (tempAmount > 1) {
            setTempAmount(tempAmount - 1);
        }
    }

    useEffect(() => {
        // console.log(isEditing)
        // if (isEditing) {
        //     console.log('aaa');
        //     setTempAmount(product.quantity);
        // }
    }, []);

    return (
        <Dialog PaperProps={{style: {borderRadius: !isMobile ? '1.5rem' : '', border: '1px solid #09382b'}}} fullScreen={isMobile}
                onClose={handleClose} open={open} fullWidth={true}>
            <DialogTitle>{product.name}
                <button className="px-1.5" onClick={() => setOpenInfoModal(true)}><Info color='secondary' /></button>
                <ProductInformationModal product={product} onClose={handleCloseInfoModal} open={openInfoModal} />
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <div className="flex flex-col h-full">
                    <div className="h-full overflow-auto">
                        {product.description &&
                            <p className="py-2 text-gray-500">
                                {product.description}
                            </p>
                        }
                        <div className="font-semibold pb-6">€ {product.price.toFixed(2).replace('.', ',')}</div>

                        {product.optionGroups.length > 0 &&
                            product.optionGroups.map((group) =>
                                <div className="product-options mb-4" key={isEditing ? 'edit_' : 'new_' + group.id}>
                                    {!group.multiChoice &&
                                        <><InputLabel id="option-label">{group.name}</InputLabel>

                                            <Select
                                                fullWidth
                                                labelId="option-label"
                                                id="option-group"
                                                value={option}
                                                label="Age"
                                                onChange={(e) => handleChange(e)}
                                            >
                                                {group.options.map(option =>
                                                    <MenuItem key={isEditing ? 'edit_' : 'new_' + option.id}
                                                              value={option.id}>{option.name + (option.price !== 0 ? ' (+€ ' + option.price.toFixed(2).replace('.', ',') + ')' : '')}

                                                    </MenuItem>
                                                )
                                                }
                                            </Select></>
                                    }
                                </div>
                            )
                        }

                        {product.optionGroups.length > 0 &&
                            product.optionGroups.map((group) =>
                                <div className="product-options" key={isEditing ? 'edit_' : 'new_' + group.id}>
                                    {group.multiChoice &&
                                        <>
                                            <FormGroup>
                                                {group.options.map(option =>
                                                    <FormControlLabel key={isEditing ? 'edit_' : 'new_' + option.id}
                                                                      control={<Checkbox
                                                                          onChange={(e) => handleChangeBox(e, option)}/>}
                                                                      label={option.name + (option.price !== 0 ? ' (+€ ' + option.price.toFixed(2).replace('.', ',') + ')' : '')}
                                                    />)}
                                            </FormGroup>
                                        </>
                                    }
                                </div>
                            )
                        }

                    </div>

                    <div className="flex justify-end pt-8 pb-6">
                        <div className="flex flex-shrink-0 w-2/5 md:w-1/3 py-1 md:py-0.5 pr-4">
                            <ActionIconButtonGrey
                                onClick={() => removeItem()}
                                variant="contained"
                                color="">
                                <HorizontalRule />
                            </ActionIconButtonGrey>
                            <div className="flex items-center justify-center w-1/3 px-2">{tempAmount}</div>
                            <ActionIconButtonPlus
                                onClick={() => addExtraItem()}
                                variant="contained"
                                color="secondary">
                                <Add />
                            </ActionIconButtonPlus>
                        </div>
                        <ActionButton
                            onClick={handleAdd}
                            variant="contained"
                            color="secondary">
                            € {(tempAmount * totalPrice).toFixed(2).replace('.', ',')}
                        </ActionButton>
                    </div>
                </div>
            </DialogContent>

        </Dialog>
    );
}
MealModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};